// Generic Drive preview (PDF, image, Word, etc.) via /preview URL.
export default function ReadOnlyPreview({ file }) {
  // Convert the file id into Drive's preview embed URL
  const src = `https://drive.google.com/file/d/${file.id}/preview`;
  return (
    <iframe
      src={src}
      title={file.name}
      className="w-full h-full border-0"
      allow="autoplay"
    />
  );
}
